
import ItemNotFound from '@/components/common/ItemNotFound.vue'
import PageHeader from '@/components/common/PageHeader.vue'
import SerialList from '@/components/serial/SerialList.vue'
import DataTableMixin from '@/components/mixins/DataTableMixin.vue'
import { FETCH_SERIALS } from '@/store/actions'
import { FILTER_DEBOUNCE_TIME } from '@/utils/constants'
import errorHandler from '@/utils/errorHandler'
import { ISerial } from '@/utils/types/model/serial'
import debounce from 'lodash/debounce'
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'

interface ICommonSearch {
  code?: string
  sortBy?: string
  sortType?: string
  [key: string]: string | undefined
}

@Options({
  components: { PageHeader, ItemNotFound, SerialList },
  name: 'Serial',
})
export default class Serial extends Mixins(DataTableMixin) {
  dataSearch: ICommonSearch = {}
  debounceFilter!: () => void

  get isSerialLoading(): boolean {
    return this.$store.getters.isSerialLoading || false
  }

  get getSerialTotalRecords(): number {
    return this.$store.getters.getSerialTotalRecords || 0
  }

  get getSerials(): ISerial[] {
    return this.$store.getters.getSerials || []
  }

  refreshItemList() {
    this.debounceFilter()
  }

  handleDetail(code: number | string) {
    this.$router.push({ name: 'serial-detail', params: { id: code.toString() } })
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.dataSearch.sortBy = data.prop
    this.dataSearch.sortType = data.order ? (data.order === 'ascending' ? 'asc' : 'desc') : undefined
    this.currentPageNum = 1
    this.redirectIndex()
    this.fetchList()
  }

  fetchList() {
    try {
      this.$store.dispatch(FETCH_SERIALS, {
        page: this.currentPageNum,
        limit: this.itemsPerPage,
        code: this.dataSearch.code || '',
        sortBy: this.dataSearch.sortBy,
        sortType: this.dataSearch.sortType,
      })
    } catch (e) {
      errorHandler(e, {}, true)
    }
  }

  created() {
    this.routeName = 'serial'
    this.getQueryData()
    this.debounceFilter = debounce(() => {
      this.currentPageNum = 1
      this.redirectIndex()
      this.fetchList()
    }, FILTER_DEBOUNCE_TIME)
    this.fetchList()
  }

  currentPageChange(pageNum: number) {
    this.currentPageNum = pageNum
    this.redirectIndex()
    this.fetchList()
  }
}
